import * as React from 'react'

function HeaderHelpCenterButton({}) {
  const toggleHelpCenter = () => {
    if (window.helpCenterOpen) {
      window.hideHelpCenter();
    } else {
      window.showHelpCenter();
    }
  }

  return <a className="header-button" onClick={toggleHelpCenter}>
    <div className="d-flex align-items-center">
      <i className="fas fa-question-circle d-flex justify-content-center m-auto"/>
    </div>
  </a>
}

export default HeaderHelpCenterButton